module.exports = __webpack_public_path__ + "static/media/3.question.485a5194.mp4";